export const environment = {
  production: false,
  local: false,
  development: true
};

export const enum Protocol {
  http = 'http://',
  https = 'https://',
  wss = 'wss://',
}

export const enum EntityPath {
  odata = 'odata.dev.g.actuar.cloud',
  base = 'actuar-api.dev.g.actuar.cloud',
  afig = 'afig-api.dev.g.actuar.cloud',
  paguela = 'paguela-api.dev.g.actuar.cloud',
  chat = 'chat-api.dev.g.actuar.cloud',
  file_group = 'filegroup-api.dev.g.actuar.cloud',
  workout_service = 'workoutservice-api.dev.g.actuar.cloud',
  workout_view = 'workoutviewservice-api.dev.g.actuar.cloud',
  activity_service = 'activityservice-api.dev.g.actuar.cloud',
  user_service = 'userservice-api.dev.g.actuar.cloud',
  shortener = 'link.pague.la',
  post_service = 'postservice-api.dev.g.actuar.cloud',
  account_service = 'accountservice-api.dev.g.actuar.cloud',
  receivable_service = 'receivableservice-api.dev.g.actuar.cloud',
  client_notification = 'clientnotification-api.dev.g.actuar.cloud',
  acesso = 'acesso-api.dev.g.actuar.cloud',
  graduation_service = 'graduationservice-api.dev.g.actuar.cloud',
  client_device_service = 'clientdeviceservice-api.dev.g.actuar.cloud',
  physical_assessment_service = 'physicalassessmentservice-api.dev.g.actuar.cloud',
  storage_service = 'storageservice-api.dev.g.actuar.cloud',
  file_group_service = 'filegroupservice-api.dev.g.actuar.cloud',
  person_service = 'personservice-api.dev.g.actuar.cloud',
  subscription_service = 'subscriptionservice-api.dev.g.actuar.cloud',
  data_service = 'dataservice-api.prd.g.actuar.cloud',
}

export const URLS = {
  actuar_web: 'https://app.actuar.com',
  new_actuar_web: 'https://app.dev.actuar.dev',
  treino_web: 'http://localhost:4200',
};

export const braspag = {
  providerMerchantId: 'c7f999ad-0ea4-4621-9fd6-6b3d475c5d70',
  providerOrgId: '1snn5n9w'
};

export const url = (
  protocol: Protocol,
  entityPath: EntityPath,
  restUrl?: any
) => `${protocol}${entityPath}${restUrl}`;

export const successCodesCheckout: string[] = ['0', '00', '000', '0000'];